import Link from 'next/link';

import styles from './CommentedLink.module.scss';

export type CommentedLinkProps = {
  caption: string;
  linkId?: string;
  linkHref: string;
  linkCaption: string;
};

export const CommentedLink = ({ caption, linkId, linkHref, linkCaption }: CommentedLinkProps) => {
  return (
    <div className={styles.container}>
      <p>{caption}</p>
      <Link id={linkId} href={linkHref}>
        {linkCaption}
      </Link>
    </div>
  );
};
